import { DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesOrderIdQuickInfo extends Layout {
    panel1: Panel;
    sourceMovement: DataSource;
    sourceStop: DataSource;
    tableStop: Table;
    textboxBillDistance: Textbox;
    textboxFreightCharge: Textbox;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
}
